/**************************************************
 * Nombre:       Seccion_Blog
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Blog_Contenido from "./Componentes/Blog_Contenido";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {collection, limit, orderBy, query} from "firebase/firestore";
import {fire} from "../../fire";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Blog = () => {
    const parms = useParams()
    const [blog, setBlog] = useState({})

    useEffect(() => {

        irArriba()

        if (parms && parms.id) {
            obtenerDoc('blogs', parms.id).then((dox) => {
                if (dox.res) {
                    setBlog(dox.data);
                }
            })
        } else {
            let q = query(collection(fire, 'blogs'), orderBy('fechaPublicacion'), limit(1))
            obtenerColeccionQuery(q).then((dox) => {
                if (dox.res && dox.data[0]) {
                    setBlog(dox.data[0]);
                }
            })
        }


    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8, zIndex: 1}}>

            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    //  backgroundImage: `url(${fondo})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    py: 0,
                    mt: -10,
                    zIndex: 2
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Blog_Contenido item={blog}/>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Seccion_Blog